module.exports = __webpack_public_path__ + "demo-game.2109fb2.mp3";